module.exports = __webpack_public_path__ + "img/Embroidery.b0673d15.png";